import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=2b193bf8&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=ts&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports